// extracted by mini-css-extract-plugin
export default {"inner-container":"documentDownloadPage_inner-container__+n9CL"};